import { CoordsType } from "../../types/types"

type GetMapLinkPropsType = CoordsType & {
  text?: string
  zoom?: number
}

const ZOOM_DEFAULT = 12

const getRouteLinkYaMap = ({
  latitude,
  longitude,
  zoom = ZOOM_DEFAULT,
}: GetMapLinkPropsType): string =>
  `https://yandex.ru/maps/?rtext=~${latitude},${longitude}&z=${zoom}`

export type { GetMapLinkPropsType }
export { getRouteLinkYaMap }

// https://yandex.ru/maps/213/moscow/?ll=37.306875%2C55.638039&rtext=~43.405722%2C39.958196&rtt=mt&ruri=~&z=14
